import { Component, Input, OnChanges, inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { islandBackdropHtml, upgradeArtHtml } from "./island-art.generated";

@Component({
  selector: "app-adventure-island-backdrop",
  standalone: true,
  template: `<span
    class="adventure-island-backdrop contents"
    [innerHTML]="trustedHtml"
  ></span>`,
})
export class AdventureIslandBackdropComponent implements OnChanges {
  private readonly sanitizer = inject(DomSanitizer);

  @Input() routeProgress = 0;
  trustedHtml: SafeHtml = this.toTrustedHtml(this.routeProgress);

  ngOnChanges() {
    this.trustedHtml = this.toTrustedHtml(this.routeProgress);
  }

  private toTrustedHtml(routeProgress: number): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      islandBackdropHtml(routeProgress),
    );
  }
}

@Component({
  selector: "app-island-upgrade-art",
  standalone: true,
  template: `
    <span
      class="block h-full w-full"
      [class.upgrade-art-campfire]="kind === 'campfire'"
      [class.upgrade-art-windmill]="kind === 'hut'"
      [innerHTML]="trustedHtml"
    ></span>
  `,
})
export class IslandUpgradeArtComponent implements OnChanges {
  private readonly sanitizer = inject(DomSanitizer);

  @Input() kind = "market";
  trustedHtml: SafeHtml = this.toTrustedHtml(this.kind);

  ngOnChanges() {
    this.trustedHtml = this.toTrustedHtml(this.kind);
  }

  private toTrustedHtml(kind: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(upgradeArtHtml(kind));
  }
}
